module.exports = __webpack_public_path__ + "img/token-creator.361d7dd8.svg";